import {AbstractControl, ValidatorFn} from '@angular/forms';
import {values, isArray} from 'lodash';

export function numberOfRequiredFieldsValidator(requiredFields: number):  ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} => {

    const setFields = values(control.value)
      .filter(field => isArray(field) && field.length > 0 || !isArray(field) && field !== null && field !== undefined);

    return setFields.length < requiredFields
      ? { 'numberOfRequiredFields': { required: requiredFields, fields: setFields } }
      : null;
  };
}



// WEBPACK FOOTER //
// ./node_modules/@cicero/webui/lib/core/validators/min-values.validator.ts